import { Component, OnInit, Input, AfterViewInit, ViewEncapsulation, OnChanges, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { CodeListModel } from './code-list.model';
import { GetCodeListService } from '../../combo-box/code-combo-box/api-services/get-code-list.service';

/**
 * コードリストクラス
 *
 * @export
 * @class CodeListComponent
 * @implements {OnInit}
 * @implements {AfterViewInit}
 */
@Component({
  selector: 'app-code-list',
  templateUrl: './code-list.component.html',
  styleUrls: ['./code-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CodeListComponent implements OnInit, AfterViewInit, OnChanges {

  /* FlexのUI再現のため 最後にクリックされたIDを取得 */
  public lastClickId: string = <string>'';

  /* モデルインスタンス化 */
  public codeListModel = new CodeListModel();

  @ViewChild('list', { static: true }) public list: ElementRef;

  @Input() public subid: string = null;
  /* 位置調整用のパラメーター */
  @Input() left: number = <number>0;
  @Input() top: number = <number>0;
  @Input() width: number | string;
  @Input() height: number | string;
  @Input() tabindex: number = <number>-1;

  /* そのほかパラメーター */
  @Input() codeDiv: string = <string>'';                                        // 画面に表示させないコード
  @Input() initFocusItem: any = null;
  @Input() forcedEnabledMode: string = null;

  private _initFocusItem: any = null;
  private _codeDiv: string = null;

  // 選択アイテム
  public selectedItems: any;

  /**
   * コンストラクタ
   *
   * @param {GetCodeListService} getCodeListService
   * @memberof CodeListComponent
   */
  constructor(
    private getCodeListService: GetCodeListService,
    public elementRef: ElementRef,
    ) { }

  /**
   * 初期処理
   *
   * @memberof CodeListComponent
   */
  ngOnInit(): void {
    // 自身をモデルに入れる
    this.codeListModel.codeList = this;
    this.list.nativeElement.setAttribute('id', this.subid + '_sub');
    this.list.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * ロード完了時
   *
   * @memberof CodeListComponent
   */
  ngAfterViewInit(): void {
    // データ取得
    this.getCodeListService.execute(this.codeListModel, this._codeDiv, '');
  }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof CodeListComponent
   */
  ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'initFocusItem':
          // 初期フォーカス設定コントロール
          this._initFocusItem = changes.initFocusItem.currentValue;
          break;
        case 'codeDiv':
          // コード区分
          this._codeDiv = changes.codeDiv.currentValue;
          break;
      }
    });
  }

  /**
   * コード更新完了 渡されたID属性へ遷移する
   *
   * @memberof CodeListComponent
   */
  public updateListComplete(): void {
    if (this._initFocusItem != null) {
      if (this.initFocusItem instanceof HTMLElement) {
        this.initFocusItem.focus();
      } else {
        // 参照先の型がElementでない(Component)ならComponent内の要素を見て最初のinput,textarea,selectElementにフォーカスをあてる
        for (const child of this.initFocusItem.elementRef.nativeElement.children) {
          if (child instanceof HTMLInputElement || child instanceof HTMLTextAreaElement || child instanceof HTMLSelectElement) {
            child.focus();
            break;
          }
        }
      }
      this._initFocusItem = null;
    }
  }

}
